import { render, staticRenderFns } from "./SecondaryManufacturer.vue?vue&type=template&id=3ffe049e&"
import script from "./SecondaryManufacturer.vue?vue&type=script&lang=js&"
export * from "./SecondaryManufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports